module.exports = __webpack_public_path__ + "img/btn_sopo_stibee.32810446.svg";